import { render, staticRenderFns } from "./edit-btn.vue?vue&type=template&id=3c6f9926&"
import script from "./edit-btn.vue?vue&type=script&lang=ts&"
export * from "./edit-btn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports